module.exports = __webpack_public_path__ + "media/fonts/CircularStd-Medium-61d34836290643301a5bf25255126d12.svg";